import React, {useState} from "react";
import axios from "axios";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";
import { Button, Control, Field, Icon, Input } from "@allxsmith/bestax-bulma";




export function VehicleTypeTrackerRow({type, dataFresh, onVehicleTrackerTypeUpdate, index}){
    const dispatch = useDispatch();
    const [typeData, setTypeData] = useState(type);
    const [editable, setEditable] = useState(false);

    const onDelete = () => {
        const conf = {
            url: "api/vehicletrackertype/"+type.id,
            method: "delete"
        };
        axios(conf).then((res) => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            if(err){
                toast.error("There was an error", {position: "top-right"});
            }
        })
    };

    const onEdit = e => {
        e.stopPropagation();
        setEditable(!editable);
    };

    const submitUpdate = e => {
        e.stopPropagation();
        const url = "api/vehicletrackertype/" + typeData.id;
        const conf = {
          method: "put",
          data: typeData,
          url
        };

        axios(conf).then(() => {
          setEditable(false);
          dispatch(createSetDataFreshAction(dataFresh + 1));
        });
    };

    const onChange = e => {
        let newVehicleTrackerType = { ...type };
        newVehicleTrackerType[e.target.name] = e.target.value || null;
        setTypeData(newVehicleTrackerType);
        onVehicleTrackerTypeUpdate(index, newVehicleTrackerType);
    };


    // TODO(bestax-migrate): bestax Icon renders from a `name` prop, not children; convert this icon markup by hand
    // TODO(bestax-migrate): `align` — inside a Control use its hasIconsLeft/iconLeft (or right) props instead
    return (
        <tr key={type.id}>
            <td>
                <Field onClick={e => e.stopPropagation()} className="has-addons">
                    <Control>
                        <Input
                            type={"text"}
                            name={"name"}
                            value={typeData.name}
                            disabled={!editable}
                            onChange={onChange}
                        />
                    </Control>
                    {editable ? (
                        <Control>
                            <Button color="success" onClick={submitUpdate}>
                                Save
                            </Button>
                        </Control>
                    ) : (
                        <Control>
                            <Button onClick={onEdit}>Edit</Button>
                        </Control>
                    )}
                </Field>
            </td>
            <td>
                <Field onClick={e => e.stopPropagation()} className="has-addons">
                    <Control>
                        <Input
                            type={"number"}
                            name={"cost"}
                            value={typeData.cost}
                            disabled={!editable}
                            onChange={onChange}
                        />
                    </Control>
                    {editable ? (
                        <Control>
                            <Button color="success" onClick={submitUpdate}>
                                Save
                            </Button>
                        </Control>
                    ) : (
                        <Control>
                            <Button onClick={onEdit}>Edit</Button>
                        </Control>
                    )}
                </Field>
            </td>
            <td>
                <Field onClick={e => e.stopPropagation()} className="has-addons">
                    <Control>
                        <Input
                            type={"number"}
                            name={"upfront_cost"}
                            value={typeData.upfront_cost}
                            disabled={!editable}
                            onChange={onChange}
                        />
                    </Control>
                    {editable ? (
                        <Control>
                            <Button color="success" onClick={submitUpdate}>
                                Save
                            </Button>
                        </Control>
                    ) : (
                        <Control>
                            <Button onClick={onEdit}>Edit</Button>
                        </Control>
                    )}
                </Field>
            </td>
            <td>
                <Button
                    color={"danger"}
                    onClick={onDelete}
                >
                    Delete X
                </Button>
            </td>
        </tr>
    );

}